module.exports = [
  { uri: '/kanjigame/create', title: 'CREATE' },
  { uri: '/kanjigame/join', title: 'JOIN' },
];
